import styled from 'styled-components';
import { BORDERS } from 'variables/theme';

export const InnerWrapper = styled.div`
  border-bottom: ${BORDERS.generic};
  margin-bottom: 1rem;
  padding-bottom: 1rem;
`;
